export default __webpack_public_path__ + "images/JK.d59c5cf.png";